import React, {useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ProjectDetailInfo from '../../../components/techmng/detail/ProjectDetailInfo';
import { viewEstimate } from '../../../modules/techModule/projectEstimate';

const ProjectDetailInfoContainer = () => {
  const dispatch = useDispatch();
  const { project , estimate} = useSelector(({ techModule }) => ({
    project: techModule.project.project,
    estimate: techModule.projectEstimate.estimate,
  }));

  useEffect(() => {
    if (project) {
     // console.log(chance, "chance");
     dispatch(viewEstimate(project.prjUuid));
    }
  }, [dispatch, project])

  return <ProjectDetailInfo project={project} estimate={estimate}/>;
};

export default ProjectDetailInfoContainer;
